import { useEffect } from 'react';
import { useUIStore } from '@/stores/ui';

export type Theme = 'light' | 'dark';

export const useTheme = () => {
  const { currentTheme, setTheme } = useUIStore();

  useEffect(() => {
    const root = window.document.documentElement;
    
    root.classList.remove('light', 'dark');
    
    if (currentTheme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.add('light');
    }
  }, [currentTheme]);

  const toggleTheme = () => {
    setTheme(currentTheme === 'light' ? 'dark' : 'light');
  };

  return {
    theme: currentTheme,
    setTheme,
    toggleTheme,
    isDark: currentTheme === 'dark',
    isLight: currentTheme === 'light'
  };
};